import { useBreakpointValue } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export const useIsDesktop = () => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const [isPageLoaded, setIsPageLoaded] = useState(false); // Track when everything is ready

  // Removes flashing effect between lottie & static image
  // because breakpoint value only works after page is loaded
  useEffect(() => {
    setIsPageLoaded(true);
  }, []);

  return {
    isDesktop,
    isPageLoaded,
  };
};
